class LangSwitcher {

	constructor(el) {
		this.el = el;

		this.build();
	}

	build() {
		this.el.querySelector('button').setAttribute('aria-expanded', false);

		this.el.querySelector('button').addEventListener('click', e => {
			this.el.classList.toggle('active');

			if(this.el.classList.contains('active')) {
				this.el.querySelector('button').setAttribute('aria-expanded', true);
			}
			else {
				this.el.querySelector('button').setAttribute('aria-expanded', false);
			}
		});

		document.body.addEventListener('click', e => {
			if(!this.el.contains(e.target)) {
				this.el.querySelector('button').setAttribute('aria-expanded', false);
				this.el.classList.remove('active');
			};
		});
	}
}

export default LangSwitcher;
